'use client';

import { useEventListener } from 'scripts';
import { CacheBackTypeEnum, OrderType, ServiceType } from 'types';
import { Fragment, useContext, useEffect, useState } from 'react';
import { RiDiscountPercentFill } from 'react-icons/ri';
import { COLORS } from 'utilities';
import { GlobalContext } from 'context';
import { PATH } from 'data';
import styles from './orderPrint.module.scss';
import Image from 'next/image';
import Subtract from 'assets/images/Subtract2.svg';
const OrderDetailSuccessComp = () => {
  const {
    langText
  } = useContext(GlobalContext);
  const lang = langText.components;
  const [serviceData, setServiceData] = useState<ServiceType>();
  const [orderData, setOrderData] = useState<OrderType>();
  const benefits = (serviceData?.cash_back ? `${serviceData.cash_back} ${serviceData.cash_back_type === CacheBackTypeEnum.constant ? '$' : '%'}  ${serviceData.cash_back_label ?? lang.refund}` : '') + (serviceData?.extra_service?.length ? ' + ' + serviceData.extra_service.join(' + ') : '');
  useEffect(() => {
    window.parent.postMessage('PRINT_IFRAME_LOADED', '*');
  }, []);
  useEventListener('message', (event: {
    data: string;
  }) => {
    if (event.data) {
      try {
        const data: {
          service: ServiceType;
          order: OrderType;
        } = JSON.parse(event.data);
        setServiceData(data.service);
        setOrderData(data.order);
      } catch (err) {
        console.log('Error: ', err, '  Data:', event.data);
      }
    }
  });
  return <div className={styles['print-content']} data-sentry-component="OrderDetailSuccessComp" data-sentry-source-file="orderPrint.index.tsx">
            <div className="gap-16 mt-1">
                <RiDiscountPercentFill size={28} color={COLORS.green} data-sentry-element="RiDiscountPercentFill" data-sentry-source-file="orderPrint.index.tsx" />
                <span>{lang.initializeSuccess}</span>
            </div>
            <div className={`${styles['service-modal']} justify-content-between mb-3 gap-32`}>
                <div className={`flex-1`}>
                    <p className="mt-2">
                        {lang.initialDescription.map((i, j) => <Fragment key={j}>
                                {i === 'brand' && serviceData ? <a className="t-primary" href={PATH(langText.lang).brand(serviceData.brand.slug)} target="_blank">
                                        {' '}
                                        {serviceData.brand.title}
                                    </a> : i === 'link' ? <a className="t-primary" href={PATH(langText.lang).panel.orders()} target="_blank">
                                        {' '}
                                        {lang.initialLink}
                                    </a> : i === 'benefits' ? <span className="t-500"> {benefits}</span> : <span> {i}</span>}
                            </Fragment>)}
                    </p>
                    <p>{lang.initialWarning}</p>
                </div>
            </div>
            <div className="gap-8 justify-content-between">
                <div className="flex-1">
                    {serviceData?.brand.address ? <div className="mt-3">
                            <p className="t-dark1 t-700 t-p1 mb-1">{lang.address}</p>
                            <p className="t-p1 t-400 t-dark2">{serviceData.brand.address}</p>
                        </div> : null}
                    {serviceData?.brand.phone ? <div className="mt-2">
                            <p className="t-dark1 t-700 t-p1 mb-1">{lang.phoneNumber}</p>
                            <p className={`t-p1 t-400 ${styles['phone']}`}>
                                <a className="t-primary" href={`tel:${serviceData.brand.phone.split(' ').join('')}`}>
                                    {serviceData.brand.phone}
                                </a>
                            </p>
                        </div> : null}
                </div>
                <div className={`${styles['qr-code']}`}>
                    {orderData?.qr_code ? <img src={orderData.qr_code?.file} alt="qr code" /> : null}
                </div>
            </div>
            <div className={`${styles['service-items']} align-items-center justify-content-between pv-2 ph-3`}>
                <div>
                    <p className="t-400 t-p1 t-primary">{lang.title_desc}</p>
                    <ul className="ph-3 t-primary">
                        <li className={`t-700 t-h4 t-primary ${!serviceData?.cash_back ? 'd-none' : ''}`}>
                            {serviceData?.cash_back}
                            {serviceData?.cash_back_type === CacheBackTypeEnum.constant ? '$' : '%'}{' '}
                            {serviceData?.cash_back_type === CacheBackTypeEnum.constant ? lang.refund2 : lang.refund_percent}
                        </li>
                        {serviceData?.extra_service?.map((service, index) => <li key={index} className="t-700 t-h4">
                                {service}
                            </li>)}
                    </ul>
                </div>
                <Image src={Subtract} alt="Subtract" width={95} height={95} data-sentry-element="Image" data-sentry-source-file="orderPrint.index.tsx" />
            </div>
            {serviceData?.use_terms ? <div className="mt-2">
                    <p className="t-dark1 t-700 t-p1 mb-1">{lang.useCondition}</p>
                    <p className={`t-p1 t-400 t-dark2`}>{serviceData?.use_terms}</p>
                </div> : null}
        </div>;
};
export default OrderDetailSuccessComp;